<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">

        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <j-input placeholder="搜索题目名称" v-model="queryParam.stem"></j-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
              style="margin-bottom:0px;"
              label=""
              :required="false"
            >
              <j-dict-select-tag v-model="queryParam.type" placeholder="全部题型" dictCode="exercise_type" />
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
              style="margin-bottom:0px;"
              label=""
              :required="false"
            >
              <j-dict-select-tag v-model="queryParam.subject" placeholder="全部科目" dictCode="subject" />
            </a-form-item>
          </a-col>

          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
          <a-button type="primary" @click="searchReset()" style="margin-left:5px;vertical-align: middle;">重置</a-button>
          <a-button @click="exportExecl()" type="primary" style="float:right;margin-left:5px" >导入题目</a-button>
          <a-button @click="changeTypeBatch()" type="primary" style="float:right;margin-left:5px" >转移</a-button>
          <a-button @click="batchDelete()" type="primary" style="float:right;margin-left:5px" >删除</a-button>

        </a-row>
      </a-form>
    </div>
    <div class="tree-con">
      <div class="tree-left">
        <!-- <a-input-search style="margin-bottom: 8px" placeholder="Search" @change="onChange" /> -->
        <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" placeholder="请输入分类名称"/>
        <a-tree
          :tree-data="gData"
          @select="onSelect"
          :auto-expand-parent="autoExpandParent"
          :selectedKeys="[queryParam.catalogId]"
          :expandedKeys="iExpandedKeys"
          :defaultExpandAll="defaultExpandAll"
          @expand="onExpand"
        >
          <template slot="title" slot-scope="item">
            <div class="title-con" v-if="!item.editable">
              <div class="title-name" >
                {{ item.title }}
              </div>
              <div class="title-operat">
                <a-icon type="plus-circle" @click="addCatalog(item)" class="op-icon"/>
                <a-icon type="form" v-if="item.key!=item.subject" @click="editCatalog(item)" class="op-icon"/>
                <a-icon type="delete" v-if="item.key!=item.subject"  @click="deleteCatalog(item)" class="op-icon"/>
              </div>
            </div>
            <div class="title-con" v-if="item.editable">
            <input v-model="inputTitle" placeholder="请输入分类" />
              <div class="title-operat">
                <a-icon type='close' @click="onClose(item)" class="op-icon"/>
                <a-icon type='check' @click="onSave(item)" class="op-icon"/>
              </div>
            </div>
          </template>
        </a-tree>
      </div>
      <div class="tree-right">
        <a-table
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          ref="table"
          size="middle"
          :scroll="{ x: 1000 }"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          @change="handleTableChange">
          <span slot="action" slot-scope="text, record" style="width:200px">
            <a @click="topicEdite(record)">编辑题目</a>
            <a-divider type="vertical" />
            <a @click="changeType(record.id)">转移</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDeleteAction(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
          <span slot="stemInfo" slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                <p v-html="text"></p>
              </template>
              <p v-html="text" style="max-height:52px;overflow:hidden"></p>
            </a-tooltip>
            
              <!-- <div v-if="text.length > 50">
                <a-tooltip>
                  <template slot="title">
                    <p v-html="text"></p>
                  </template>
                  <p v-html="text"></p>
                </a-tooltip>
              </div>
              <div v-else>
                21321
                <p v-html="text"></p>
              </div> -->
            </span>
        </a-table>
      </div>
    </div>
    <exercise-select-type ref="exerciseSelectType" @ok="importOk"></exercise-select-type>
    <export-exercise ref="exportExercise" @ok="importOk"></export-exercise>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ExerciseSelectType from './modules/ExerciseSelectTypeModal'
  import ExportExercise from './modules/ExportExerciseModal'
  import { queryExerciseTreeList,categoryAdd,categoryEdit,categoryDelete} from '@/api/api'
  export default {
    name: 'TopicList',
    mixins: [JeecgListMixin],
    components: {
      ExerciseSelectType,
      ExportExercise
    },
    data () {
      return {
        selectedRowKeys: [],
        autoExpandParent: false,
        defaultExpandAll:true,
        gData: [
          // {
          //   id: 1,
          //   key: 1,
          //   isEdit: false, // 是否处于编辑状态
          //   isNewItem: false, // 该节点是否是新增节点
          //   title: '节点名字',
          //   depth: 1, // 该节点的层级
          //   scopedSlots: { title: 'title' }, // 自定义组件需要绑定
          //   children: [
          //     {
          //       id: 2,
          //       key: 2,
          //       isEdit: false, // 是否处于编辑状态
          //       isNewItem: false, // 该节点是否是新增节点
          //       title: '子节点名字',
          //       depth: 2, // 该节点的层级
          //       scopedSlots: { title: 'title' }
          //     },
          //     {
          //       id: 21,
          //       key: 21,
          //       isEdit: false, // 是否处于编辑状态
          //       isNewItem: false, // 该节点是否是新增节点
          //       title: '子节点名字',
          //       depth: 2, // 该节点的层级
          //       scopedSlots: { title: 'title' }
          //     }
          //   ]
          // }
        ],
        description: '题库管理',
        // subjectDictItems:{},
        queryParam: {
          type: undefined,
          stem: '',
          subject: undefined,
          catalogId:''
        },
        // 表头
        columns: [

          {
            title: '序号',
            align: 'center',
            dataIndex: 'importNo',
            width: 50
            // customRender: (text, row, index) => {
            //   return (<span >{index + 1}</span>)
            // }
          },
          {
            title: '题目',
            align: 'left',
            dataIndex: 'stem',
            width: 250,
             scopedSlots: { customRender: 'stemInfo' }
            // customRender: (text, row, index) => {
            //   if(text.length>100){
            //     return '<p v-html="text.substring(0,100)+"...""></p>';
            //     //return text.substring(0,100)+"...";
            //   }
            //   return (<p v-html="text"></p>);
            // }
          },
          {
            title: '题型',
            align: 'center',
            dataIndex: 'type_dictText',
            width: 100
          },
          {
            title: '科目',
            align: 'center',
            dataIndex: 'subject_dictText',
            width: 60

          },
          {
            title: '题目分类',
            align: 'center',
            dataIndex: 'catalogId_dictText',
            width: 100

          },
          // {
          //   title: '正确答案',
          //   align: 'center',
          //   dataIndex: 'zqda',
          //   width: 100
          // },
          {
            title: '分值',
            align: 'center',
            dataIndex: 'score',
            width: 60
          },
          {
            title: '知识点',
            align: 'center',
            dataIndex: 'knowledgePoints',
            width: 100
          },
          {
            title: '出处',
            align: 'center',
            dataIndex: 'exerciseSrc',
            width: 100
          },
          {
            title: '更新时间',
            align: 'center',
            dataIndex: 'updateTime',
            width: 100,
            customRender: (text, row, index) => {
              if(text){
                return text;
              }
              return row.createTime;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed:'right',
            scopedSlots: { customRender: 'action' },
            width: 180
          }
        ],
        // editNode:{},
        inputTitle:"",
        iExpandedKeys: [],
        dataSource: [
          // {
          //   tm: '我是题目',
          //   tx: '问题求解',
          //   km: '数学',
          //   tmfl: '2018年整卷',
          //   zqda: 'A',
          //   fz: '3',
          //   cc: '2018年1月',
          //   zsd: '2018年1月',
          //   gxsj: '2021/02/19 09:29:29'
          // }
        ],
        // 请求参数
        url: {
          list: '/exercise/elinkxExerciseInfo/list',
          delete: '/exercise/elinkxExerciseInfo/delete',
          deleteBatch: '/exercise/elinkxExerciseInfo/deleteBatch',
          // exportXlsUrl: '/exercise/elinkxExerciseInfo/exportXls',
          importExcelUrl: 'exercise/elinkxExerciseInfo/importExcel'
        }
        }
      },
      computed: {
        importExcelUrl: function() {
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
        }
      },

    methods: {
      batchDelete(){
        this.batchDel();
        setTimeout(callback=>this.loadTree(),2000);
      },
      handleDeleteAction(id){
        this.handleDelete(id);
        setTimeout(callback=>this.loadTree(),2000);
      },

      importOk(){
        this.loadTree();
        this.loadData();
      },
      onClose(item){
        if(item.id){
         this.searchOption(item,this.gData,"cancel");
        }else{
          this.searchOption(item,this.gData,"delete");
        }
      },
      onSave(item){
        if(!this.inputTitle){
          this.$message.warning("请输入分类名！");
          return;
        }
        const param = {
          pid:item.pid,
          subject:item.subject,
          name:this.inputTitle,
          id:item.id
        }
        if(item.id){
          categoryEdit(param).then((res)=>{
            if(res.success){
              this.loadTree();
            }
          })
        }else{
          categoryAdd(param).then((res)=>{
            if(res.success){
              this.loadTree();
            }
          })
        }
      },
      editCatalog(item){
        this.searchOption(item,this.gData,"edit");

      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      addCatalog(item){
        this.iExpandedKeys.push(item.key);
        // const editNode = {
        //     title: '编辑菜单',
        //     key: (new Date()).getTime(),
        //     scopedSlots: {title: 'title'},
        //     pid:item.key,
        //     editable:true,
        //     subject:item.subject,
        //     children: []
        // };
        // this.inputTitle  = editNode.title;
        // if (!item.children) {
        //   this.$set(item, 'children', [])
        // }
          // item.children.push(editNode)
          this.searchOption(item,this.gData,"add");
      },
      deleteCatalog(item){
        categoryDelete({id:item.id}).then((res)=>{
          if(res.success){
            this.searchOption(item,this.gData,"delete");
          }else{
            this.$message.warning(res.message);
          }
        })
      },
       // 递归查找
    searchOption (option, arr, type) {
      for (let s = 0; s < arr.length; s++) {
        if (arr[s].key === option.key) {
          if (type === 'delete') {
            if(arr[s].children && arr[s].children.length > 0){
              this.$message.warning("存在子目录，不能删除！");
              return;
            }else{
              arr.splice(s, 1)
            }
          } else if(type === "edit"){
            arr[s].editable = true;
            this.inputTitle  = arr[s].name;
          }else if(type === "cancel"){
            arr[s].editable = false;
          }else if(type === "add"){
            const editNode = {
              title: '编辑菜单',
              key: (new Date()).getTime(),
              scopedSlots: {title: 'title'},
              pid:option.key,
              editable:true,
              subject:option.subject,
              children: []
            };
            //this.inputTitle  = editNode.title;
             if (!arr[s].children) {
                this.$set(arr[s], 'children', [])
              }
            arr[s].children.push(editNode);
          }
          break
        } else if (arr[s].children && arr[s].children.length > 0) { // 递归条件
          this.searchOption(option, arr[s].children,type)
        } else {
          continue
        }
      }
    },
      //
      onSelectChange(selectedRowKeys) {
        console.log('selectedRowKeys changed: ', selectedRowKeys)
        this.selectedRowKeys = selectedRowKeys
      },
      onChange(searchKey) {
        console.log('selectedRowKeys changed: ', searchKey)
        // this.selectedRowKeys = selectedRowKeys
      },
      onSelect(keys, event) {
        // 获取某个分类
        this.queryParam.catalogId = event.node.$vnode.key
        // keys[0]
        this.loadData()
        console.log('Trigger Select', keys, event)
      },
      loadTree() {
        queryExerciseTreeList().then((res) => {
           if (res.success) {
             this.gData = res.result
            //  this.iExpandedKeys=[]
            //     this.gData.forEach(item=>{
            //     this.iExpandedKeys.push(item.key);
            //     this.addExpandKeys(item);
            //  })
           } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
        })
      },
      // 编辑题目
      topicEdite(item) {
        this.$router.push({ path: '/exerciseManage/topicCreate?id=' + item.id })
      },
      // 批量转移
      changeTypeBatch () {
        if (this.selectedRowKeys.length === 0) {
         this.$message.warning('至少选择一条数据')
        } else {
          // this.$refs.exerciseSelectType.gData =this.gData;
          this.$refs.exerciseSelectType.open(this.selectedRowKeys)
        }
      },
      // 单个转移
      changeType: function(id) {
        this.$refs.exerciseSelectType.open([id])
      },
      // 导入题目
      exportExecl: function() {
        this.$refs.exportExercise.open()
      },
      addExpandKeys(itemData){
        if(itemData.children){
          itemData.children.forEach(item=>{
             this.iExpandedKeys.push(item.key);
          })
        }
      },
      onSearch(value) {
         let that = this
        if (value) {
          queryExerciseTreeList({ 'name': value }).then((res) => {
            if (res.success) {
              that.gData = res.result
              this.iExpandedKeys=[]
                this.gData.forEach(item=>{
                this.iExpandedKeys.push(item.key);
                this.addExpandKeys(item);
             })
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
          })
        } else {
          that.loadTree()
        }
      }

    },
    created () {
      this.loadTree()
      // this.subjectDictItems = getDictItems("subject",{});
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>

<style lang="less" scoped >
  @import '~ant-design-vue/es/style/themes/default.less';
  .title-con{
    display: flex;
    // width: 155px;
    position: relative;
    .title-name{
      flex: 1;
      overflow: hidden;
      white-space: normal;
      text-overflow: ellipsis;
    }
    .title-operat{
      position: absolute;
      right: 0px;
      // margin-right: 5px;
      top: 1px;
      background-color:#e6f7ff;
      transform: translateX(120%);
      transition-duration: 0.5s;
      .op-icon{
        margin-left: 5px;
      }
    }
    &:hover{
      .title-operat{
        transform: translateX(0%);
        display: inline-block;
        color: @primary-color;
      }
    }
  }
  .tree-con{
    display: flex;
    .tree-left{
      border:1px solid #eee;
      width: 240px;
      margin-right: 20px;
      min-height:calc(~'100vh - 180px');
      overflow: hidden;
    }
    .tree-right{
      flex:1;
      overflow: hidden;
    }
  }
</style>
